// Chamada às funções do servidor que leem a exportação do IW (FTP), com o login do usuário.
import { supabase } from '../supabase';

export async function buscarIW(endpoint) {
  const { data: { session } } = await supabase.auth.getSession();
  const resp = await fetch(`/api/${endpoint}`, { headers: { Authorization: `Bearer ${session?.access_token || ''}` } });
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(json.error || `Erro ${resp.status}`);
  return json;
}

export function fmtExportacao(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return isNaN(d) ? '—' : d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}
